import * as React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IProps {
    saveBtnTitle?: string,
    header: string,
    draftBtnTitle?: string,
    showDraftBtn?: boolean,
    save: () => void,
    saveDraft?: () => void,
    close: () => void,
    isDraft: boolean,
    children: any,
    customerManagerName?: string,
    customerManagerPhone?: string
}

export class DocumentPageHeader extends React.Component<IProps, any> {
    public render() {
        return (
            <div style={{ margin: "15px 0" }}>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <div>
                        <Button size="sm" variant="primary" onClick={this.props.save}>
                            <FontAwesomeIcon icon="save" />{" "}
                            {this.props.saveBtnTitle || "Сохранить"}
                        </Button>

                        {this.props.showDraftBtn && (
                            <Button
                                size="sm"
                                variant="info"
                                style={{ marginLeft: "10px" }}
                                onClick={this.props.saveDraft}
                            >
                                <FontAwesomeIcon icon="save" />{" "}
                                {this.props.draftBtnTitle || "Сохранить черновик"}
                            </Button>
                        )}

                        <Button
                            size="sm"
                            variant="light"
                            style={{ marginLeft: "10px" }}
                            onClick={this.props.close}
                        >
                            Закрыть
                        </Button>

                        {this.props.children}
                    </div>

                    {this.props.customerManagerName && (
                        <div style={{ textAlign: "right" }}>
                            <div>
                                <b>Личный менеджер:</b> {this.props.customerManagerName}
                            </div>
                            {this.props.customerManagerPhone && (
                                <div>
                                    <b>Телефон менеджера:</b>{" "}
                                    {this.props.customerManagerPhone}
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <br />

                <table style={{ width: "100%" }}>
                    <tbody>
                        <tr style={{ paddingTop: "5px" }}>
                            <td
                                style={{
                                    paddingRight: "10px",
                                    width: "1%",
                                    whiteSpace: "nowrap"
                                }}
                            >
                                <span style={{ fontWeight: 500 }}>
                                    {this.props.header}
                                </span>
                            </td>
                            <td>{/* <Form inline>
                                <span style={{ fontWeight: 500 }}>{' '}№{' '}</span> <FormControl type="text" size="sm" style={{ width: "70px", margin: "0 5px" }} />
                                <span style={{ fontWeight: 500 }}>{' '}от{' '}</span> <FormControl type="text" size="sm" style={{ width: "180px", margin: "0 5px" }} />
                                <Form.Group controlId="formApplicableCheckbox">
                                    <Form.Check type="checkbox" label="Черновик" checked={this.props.isDraft} />
                                </Form.Group>
                            </Form> */}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}
